import { render, staticRenderFns } from "./v-ribbon.vue?vue&type=template&id=79b5e9f8&scoped=true&"
import script from "./v-ribbon.vue?vue&type=script&lang=js&"
export * from "./v-ribbon.vue?vue&type=script&lang=js&"
import style0 from "./v-ribbon.vue?vue&type=style&index=0&id=79b5e9f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b5e9f8",
  null
  
)

export default component.exports